import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/verify-otp",
    name: "Verify otp",
    component: () => import("../views/account/verify-otp.vue"),
    meta: {
      title: "Verify OTP",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/email-otp-verify",
    name: "Email otp verify",
    component: () => import("../views/account/email-otp-verify.vue"),
    meta: {
      title: "Email otp verify",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password",
    name: "reset password",
    component: () => import("../views/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/email-verification",
    name: "email verification",
    component: () => import("../views/account/email-verification.vue"),
    meta: {
      title: "Email Verification",
    },
  },
  {
    path: "/create-shop",
    name: "create shop",
    component: () => import("../views/pages/CreateShop/create-shop.vue"),
    meta: {
      title: "Create Shop",
    },
  },
  {
    path: "/create-service",
    name: "create service",
    component: () => import("../views/pages/CreateService/create-service.vue"),
    meta: {
      title: "Create Service",
    },
  },
  {
    path: "/download-qr",
    name: "download qr",
    component: () => import("../views/pages/DownloadQR/downloadqr.vue"),
    meta: {
      title: "Download QR",
    },
  },
  {
    path: "/qr-customer-1",
    name: "qr customer 1",
    component: () => import("../views/pages/Customer-instant-qr-booking/qrpage-1.vue"),
    meta: {
      title: "QR Customer 1",
    },
  },
  {
    path: "/qr-customer-2",
    name: "qr customer 2",
    component: () => import("../views/pages/Customer-instant-qr-booking/qrpage-2.vue"),
    meta: {
      title: "QR Customer 2",
    },
  },
  {
    path: "/available-day-time",
    name: "available day time",
    component: () => import("../views/pages/AvailableDayTime/available-day-time.vue"),
    meta: {
      title: "Available Day Time",
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../views/pages/Profile/profile.vue"),
    meta: {
      title: "Profile",
    },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: () => import("../views/pages/SubscriptionDetails/subscriptionDetails.vue"),
    meta: {
      title: "Subscription",
    },
  },
  {
    path: "/permission-for-roles",
    name: "permission-for-roles",
    component: () => import("../views/pages/RoleMaster/permission-for-roles.vue"),
    meta: {
      title: "Permission for Roles",
    },
  },
  {
    path: "/employee-master",
    name: "employee-master",
    component: () => import("../views/pages/EmployeeMaster/employee-master"),
    meta: {
      title: "Employee Master",
    },
  },
  {
    path: "/category-master",
    name: "category-master",
    component: () => import("../views/pages/CategoryMaster/category-master"),
    meta: {
      title: "Category Master",
    },
  },
  // {
  //   path: "/",
  //   name: "default",
  //   meta: {
  //     title: "Dashboard",
  //     authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/ecommerce/index.vue"),
  // },
    {
    path: "/",
    name: "default",
    props: true, 
    component: () => import("../views/pages/customers_design/newdashboard.vue"),
    meta: {
      title: "sage booking",
    },
  },

  {
    path: "/client-master",
    name: "client-master",
    component: () => import("../views/pages/Client/client.vue"),
    meta: {
      title: "client-master",
    },
  },

  {
    path: "/transaction_appointment",
    name: "transaction_appointment",
    component: () => import("../views/pages/booking_dashboard/transaction_appointment.vue"),
    meta: {
      title: "transaction_appointment",
    },
  },
  {
    path: "/membership_appointment",
    name: "membership_appointment",
    component: () => import("../views/pages/booking_dashboard/membership_appointment.vue"),
    meta: {
      title: "membership_appointment",
    },
  },
  {
    path: "/coupon_appointment",
    name: "coupon_appointment",
    component: () => import("../views/pages/booking_dashboard/coupon_appointment.vue"),
    meta: {
      title: "coupon_appointment",
    },
  },

  {
    path: "/ticket_raising",
    name: "ticket_raising",
    component: () => import("../views/pages/TicketRaising/ticket_raising.vue"),
    meta: {
      title: "ticket_raising",
    },
  },
  {
    path: "/package-master",
    name: "package-master",
    component: () => import("../views/pages/PackageMaster/package_master.vue"),
    meta: {
      title: "Package Master",
    },
  },
  {
    path: "/package-service",
    name: "package-service",
    component: () => import("../views/pages/PackageMaster/package_service.vue"),
    meta: {
      title: "Package Service",
    },
  },
  {
    path: "/app-download-qr",
    name: "app-download-qr",
    component: () => import("../views/pages/AppDownloadQr/appdownloadqr.vue"),
    meta: {
      title: "app-download-qr",
    },
  },


//super_admin routes
{
  path: "/super_admin/ticket_raising",
  name: "/super_admin/ticket_raising",
  component: () => import("../views/superadmin/ticket_raising.vue"),
  meta: {
    title: "super_admin/ticket_raising",
  },
},
{
  path: "/admin_sign",
  name: "admin_sign",
  component: () => import("../views/superadmin/admin_sign.vue"),
  meta: {
    title: "admin_sign",
  },
},
{
  //main dashboard page after sign in master
  path: "/super_admin_dashboard",
  name: "super_admin_dashboard",
  component: () => import("../views/superadmin/admin_dashboard.vue"),
  meta: {
    title: "super_admin_dashboard",
  },
},
{
  path: "/country_master",
  name: "country_master",
  component: () => import("../views/superadmin/country_master.vue"),
  meta: {
    title: "country_master",
  },
},
{
  path: "/service_master",
  name: "service_master",
  component: () => import("../views/superadmin/service_master.vue"),
  meta: {
    title: "service_master",
  },
},
{
  path: "/privacy_faq",
  name: "privacy_faq",
  component: () => import("../views/superadmin/privacy_faq.vue"),
  meta: {
    title: "privacy_faq",
  },
},
// {
//   path: "/subscription_plan",
//   name: "subscription_plan",
//   component: () => import("../views/pages/superadmin/subscription_plan.vue"),
//   meta: {
//     title: "subscription_plan",
//   },
// },
{
  path: "/subscription_plan_master",
  name: "subscription_plan_master",
  component: () => import("../views/superadmin/subscription_master.vue"),
  meta: {
    title: "subscription_plan_master",
  },
},
{
  path: "/users",
  name: "users",
  component: () => import("../views/superadmin/users.vue"),
  meta: {
    title: "users",
  },
},
{
  path: "/super_permission",
  name: "super_permission",
  component: () => import("../views/superadmin/super_permission.vue"),
  meta: {
    title: "super_permission",
  },
},
{
  path: "/marketing_banner",
  name: "marketing_banner",
  component: () => import("../views/superadmin/marketing_banner.vue"),
  meta: {
    title: "marketing_banner",
  },
},
{
  path: "/referal",
  name: "referal",
  component: () => import("../views/superadmin/referal.vue"),
  meta: {
    title: "referal",
  },
},

// {
//   path: "/category_master",
//   name: "category_master",
//   component: () => import("../views/pages/superadmin/category_master.vue"),
//   meta: {
//     title: "category_master",
//   },
// },
{
  path: "/subscription_list",
  name: "subscription_list",
  component: () => import("../views/superadmin/subscription_list.vue"),
  meta: {
    title: "subscription_list",
  },
},
{
  path: "/customer_advancebooking_list",
  name: "customer_advancebooking_list",
  component: () => import("../views/superadmin/customer_advancebooking_list.vue"),
  meta: {
    title: "customer_advancebooking_list",
  },
},

{
  path: "/use_coupon",
  name: "use_coupon",
  component: () => import("../views/superadmin/coupon.vue"),
  meta: {
    title: "use_coupon",
  },
},








{
  path: "/coupon",
  name: "coupon",
  component: () => import("../views/pages/coupon/coupon_master.vue"),
  meta: {
    title: "coupon",
  },
},

{
  path: "/review-admin",
  name: "review-admin",
  component: () => import("../views/pages/reviews/reviews_admin.vue"),
  meta: {
    title: "review-admin",
  },
},
{
  path: "/generate-coupon",
  name: "generate-coupon",
  component: () => import("../views/pages/coupon/generate_coupon.vue"),
  meta: {
    title: "generate-coupon",
  },
},
{
  path: "/membership-list",
  name: "membership-list",
  component: () => import("../views/pages/Membership/membership_detail.vue"),
  meta: {
    title: "membership-list",
  },
},
{
  path: "/booking-list",
  name: "booking-list",
  component: () => import("../views/pages/Membership/booking_list.vue"),
  meta: {
    title: "booking-list",
  },
},
{
  path: "/multiple-token",
  name: "multiple-token",
  component: () => import("../views/pages/multiple_token/multiple_token.vue"),
  meta: {
    title: "multiple-token",
  },
},
{
  path: "/photo-gallery",
  name: "photo-gallery",
  component: () => import("../views/pages/photo_gallery/photo_gallery.vue"),
  meta: {
    title: "photo-gallery",
  },
},
{
  path: "/shop-settings",
  name: "shop-settings",
  component: () => import("../views/pages/settings/shop_settings.vue"),
  meta: {
    title: "shop-settings",
  },
},
{
  path: "/report",
    name: "report",
  component: () => import("../views/pages/report/report.vue"),
  meta: {
    title: "report",
  },
},
{
  path: "/memberlist",
    name: "memberlist",
  component: () => import("../views/pages/report/memberlist.vue"),
  meta: {
    title: "memberlist",
  },
},
{
  path: "/couponlist",
    name: "couponlist",
  component: () => import("../views/pages/report/couponlist.vue"),
  meta: {
    title: "couponlist",
  },
},
{
  path: "/client",
    name: "client",
  component: () => import("../views/pages/report/client.vue"),
  meta: {
    title: "client",
  },
},

{
  path: "/report",
    name: "report",
  component: () => import("../views/pages/report/report.vue"),
  meta: {
    title: "report",
  },
},

{
  path: "/client",
    name: "client",
  component: () => import("../views/pages/report/client.vue"),
  meta: {
    title: "client",
  },
},

{
  path: "/client_summary",
    name: "client_summary",
  component: () => import("../views/pages/report/client_summary.vue"),
  meta: {
    title: "client_summary",
  },
},
{
  path: "/client_insight",
    name: "client_insight",
  component: () => import("../views/pages/report/client_insight.vue"),
  meta: {
    title: "client_insight",
  },
},
{
  path: "/team",
    name: "team",
  component: () => import("../views/pages/report/team.vue"),
  meta: {
    title: "team",
  },
},
{
  path: "/couponlist",
    name: "couponlist",
  component: () => import("../views/pages/report/couponlist.vue"),
  meta: {
    title: "couponlist",
  },
},
{
  path: "/memberlist",
    name: "memberlist",
  component: () => import("../views/pages/report/memberlist.vue"),
  meta: {
    title: "memberlist",
  },
},
{
  path: "/sales_summary",
    name: "sales_summary",
  component: () => import("../views/pages/report/sales_summary.vue"),
  meta: {
    title: "sales_summary",
  },
},
{
  path: "/appointment_list",
    name: "appointment_list",
  component: () => import("../views/pages/report/appointment_list.vue"),
  meta: {
    title: "appointment_list",
  },
},
{
  path: "/appointment_summary",
    name: "appointment_summary",
  component: () => import("../views/pages/report/appointment_summary.vue"),
  meta: {
    title: "appointment_summary",
  },
},
{
  path: "/cancellation_list",
    name: "cancellation_list",
  component: () => import("../views/pages/report/cancellation_list.vue"),
  meta: {
    title: "cancellation_list",
  },
},
{
  path: "/waitlist_summary",
    name: "waitlist_summary",
  component: () => import("../views/pages/report/waitlist_summary.vue"),
  meta: {
    title: "waitlist_summary",
  },
},
{
  path: "/referal_list",
    name: "referal_list",
  component: () => import("../views/pages/Referal/referal_list.vue"),
  meta: {
    title: "referal_list",
  },
},
{
  path: "/membership_appointments",
    name: "membership_appointments",
  component: () => import("../views/pages/report/appointment_memberlist.vue"),
  meta: {
    title: "membership_appointments",
  },
},
{
  path: "/coupon_appointments",
    name: "coupon_appointments",
  component: () => import("../views/pages/report/coupon_appointment.vue"),
  meta: {
    title: "coupon_appointments",
  },
},
{
  path: "/booking_dashboard",
  name: "booking_dashboard",
  component: () => import("../views/pages/booking_dashboard/booking_dashboard.vue"),
  meta: {
    title: "booking_dashboard",
  },
},
{
  path: "/notifications",
    name: "notifications",
  component: () => import("../views/pages/notifications/notification.vue"),
  meta: {
    title: "notifications",
  },
},
{
  path: "/reschedule-list",
    name: "reschedule-list",
  component: () => import("../views/pages/notifications/rescheduleList.vue"),
  meta: {
    title: "reschedule-list",
  },
},
{
  path: "/new-appointments",
    name: "new-appointments",
  component: () => import("../views/pages/notifications/new_appointment_list.vue"),
  meta: {
    title: "new-appointments",
  },
},
{
  path: "/cancelled-appointments",
    name: "cancelled-appointments",
  component: () => import("../views/pages/notifications/cancellation_appointment_list.vue"),
  meta: {
    title: "cancelled-appointments",
  },
},

{
  path: "/tax-master",
  name: "tax-master",
  component: () => import("../views/pages/TaxMaster/tax_master.vue"),
  meta: {
    title: "tax-master",
  },
},

{
  path: "/employee-salary",
  name: "employee-salary",
  component: () => import("../views/pages/employee/employee_salary.vue"),
  meta: {
    title: "Employee Salary",
  },
},

{
  path: "/employee-services",
  name: "employee-services",
  component: () => import("../views/pages/employee/employee_services.vue"),
  meta: {
    title: "Employee Services",
  },
},



//Doctor Master

{
    path: "/doctor/category_master",
    name: "doctor/category_master",
   
    component: () => import("../views/pages/DoctorMaster/category_master.vue"),
    meta: {
      title: "doctor/category_master",
    },
  },
  {
    path: "/doctor/uom_master",
    name: "doctor/uom_master",
   
    component: () => import("../views/pages/DoctorMaster/uom_master.vue"),
    meta: {
      title: "doctor/uom_master",
    },
  },
  {
    path: "/doctor/service_master",
    name: "doctor/service_master",
   
    component: () => import("../views/pages/DoctorMaster/service_master.vue"),
    meta: {
      title: "doctor/service_master",
    },
  },
  {
    path: "/doctor/brand_master",
    name: "doctor/brand_master",
   
    component: () => import("../views/pages/DoctorMaster/brand_master.vue"),
    meta: {
      title: "doctor/brand_master",
    },
  },
  {
    path: "/doctor/product_master",
    name: "doctor/product_master",
   
    component: () => import("../views/pages/DoctorMaster/product_master.vue"),
    meta: {
      title: "doctor/product_master",
    },
  },
  {
    path: "/doctor/specialization_master",
    name: "doctor/specialization_master",
   
    component: () => import("../views/pages/DoctorMaster/specialization_master.vue"),
    meta: {
      title: "doctor/specialization_master",
    },
  },
  {
    path: "/doctor/doctor_master",
    name: "doctor/doctor_master",
   
    component: () => import("../views/pages/DoctorMaster/doctor_master.vue"),
    meta: {
      title: "doctor/doctor_master",
    },
  },
  {
    path: "/doctor/supplier_master",
    name: "doctor/supplier_master",
   
    component: () => import("../views/pages/DoctorMaster/supplier_master.vue"),
    meta: {
      title: "doctor/supplier_master",
    },
  },
  {
    path: "/DoctorMaster/dashboard",
    name: "DoctorMaster/dashboard",
   
    component: () => import("../views/pages/DoctorMaster/dashboard.vue"),
    meta: {
      title: "DoctorMaster/dashboard",
    },
  },  
  {
    path: "/doctor/employee_master",
    name: "doctor/employee_master",
   
    component: () => import("../views/pages/DoctorMaster/employee_master.vue"),
    meta: {
      title: "doctor/employee_master",
    },
  },
  {
    path: "/DoctorMaster/prescription",
    name: "DoctorMaster/prescription",
   
    component: () => import("../views/pages/DoctorMaster/prescription.vue"),
    meta: {
      title: "DoctorMaster/prescription",
    },
  },
  {
    path: "/DoctorMaster/prescription_history",
    name: "DoctorMaster/prescription_history",
   
    component: () => import("../views/pages/DoctorMaster/prescription_history.vue"),
    meta: {
      title: "DoctorMaster/prescription_history",
    },
  },

  {
    path: "/DoctorMaster/profile",
    name: "DoctorMaster/profile",
   
    component: () => import("../views/pages/DoctorMaster/profile.vue"),
    meta: {
      title: "DoctorMaster/profile",
    },
  },
  {
    path: "/doctor/role_master",
    name: "doctor/role_master",
   
    component: () => import("../views/pages/DoctorMaster/role_master.vue"),
    meta: {
      title: "doctor/role_master",
    },
  },





  //customers
  {
    path: "/cust_login",
    name: "cust_login",
    component: () => import("../views/customers/account/login.vue"),
    meta: {
      title: "cust_login",
     
    },
  },
  {
    path: "/cust_register",
    name: "cust_register",
    component: () => import("../views/customers/account/register.vue"),
    meta: {
      title: "cust_register",
    },
  },
  {
    path: "/cust_forgot_password",
    name: "cust_forgot_password",
    component: () => import("../views/customers/account/forgot-password.vue"),
    meta: {
      title: "cust_forgot_password",
    },
  },
  {
    path: "/cust/verify-otp",
    name: "Verify otp",
    component: () => import("../views/customers/account/verify-otp.vue"),
    meta: {
      title: "Verify OTP",
    },
  },
  {
    path: "/cust/email-otp-verify",
    name: "cust/email-otp-verify",
    component: () => import("../views/customers/account/email-otp-verify.vue"),
    meta: {
      title: "cust/email-otp-verify",
    },
  },
  {
    path: "/csut/reset-password",
    name: "csut/reset-password",
    component: () => import("../views/customers/account/reset-password.vue"),
    meta: {
      title: "csut/reset-password",
    },
  },
  {
    path: "/cust/email-verification",
    name: "cust/email-verification",
    component: () => import("../views/customers/account/email-verification.vue"),
    meta: {
      title: "cust/email-verification",
    },
  },
  {
    path: "/cust/profile",
    name: "cust/profile",
    component: () => import("../views/customers/Profile/profile.vue"),
    meta: {
      title: "cust/profile",
    },
  },
  {
    path: "/notification",
    name: "notification",
    component: () => import("../views/customers/support/notification.vue"),
    meta: {
      title: "Notification",
    },
  },
  {
    path: "/service-section",
    name: "service-section",
    component: () => import("../views/customers/support/service-section.vue"),
    meta: {
      title: "Service-section",
    },
  },
  {
    path: "/support",
    name: "support",
    component: () => import("../views/customers/support/support.vue"),
    meta: {
      title: "support",
    },
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/customers/support/faq.vue"),
    meta: {
      title: "faq",
    },
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("../views/customers/support/privacy-policy.vue"),
    meta: {
      title: "privacy-policy",
    },
  },
  {
    path: "/appointments",
    name: "appointments",
    component: () => import("../views/customers/support/appointments.vue"),
    meta: {
      title: "appointments",
    },
  },
  {
    path: "/edit-profile",
    name: "edit-profile",
    component: () => import("../views/customers/support/edit-profile.vue"),
    meta: {
      title: "edit-profile",
    },
  },
  {
    path: "/makeappointment",
    name: "makeappointment",
    component: () => import("../views/customers/support/makeappointment.vue"),
    meta: {
      title: "makeappointment",
    },
  },
  {
    path: "/shopList/:categoryId'",
    name: "shopList",
    props: true, 
    component: () => import("../views/customers/support/shopList.vue"),
    meta: {
      title: "ShopList",
    },
  },
  {
    path: "/customers-dashboard",
    name: "customers-dashboard",
    meta: {
      title: "customers-dashboard",
    },
    component: () => import("../views/customers/dashboard.vue"),
  },
  {
    path: "/hospital_service",
    name: "hospital_service",
    props: true, 
    component: () => import("../views/customers/support/hospital_service.vue"),
    meta: {
      title: "hospital_service",
    },
  },
  {
    path: "/service_history",
    name: "service_history",
    props: true, 
    component: () => import("../views/customers/support/service_history.vue"),
    meta: {
      title: "service_history",
    },
  },





  {
    path: "/select-services",
    name: "select-services",
    props: true, 
    component: () => import("../views/pages/customers_design/select_services.vue"),
    meta: {
      title: "select-services",
    },
  },
  {
    path: "/search-shop",
    name: "search-shop",
    props: true, 
    component: () => import("../views/pages/customers_design/search_shop.vue"),
    meta: {
      title: "search-shop",
    },
  },
  {
    path: "/new-dashboard",
    name: "new-dashboard",
    props: true, 
    component: () => import("../views/pages/customers_design/newdashboard.vue"),
    meta: {
      title: "new-dashboard",
    },
  },
  {
    path: "/shop-details",
    name: "shop-details",
    props: true, 
    component: () => import("../views/pages/customers_design/shop_details.vue"),
    meta: {
      title: "shop-details",
    },
  },
  {
    path: "/select-employee",
    name: "select-employee",
    props: true, 
    component: () => import("../views/pages/customers_design/select_employee.vue"),
    meta: {
      title: "select-employee",
    },
  },
  {
    path: "/select-time",
    name: "/select-time",
    props: true, 
    component: () => import("../views/pages/customers_design/select_time.vue"),
    meta: {
      title: "/select-time",
    },
  },
  {
    path: "/my-appointment",
    name: "/my-appointment",
    props: true, 
    component: () => import("../views/pages/customers_design/appointments.vue"),
    meta: {
      title: "/my-appointment",
    },
  },
  {
    path: "/my-favourites",
    name: "/my-favourites",
    props: true, 
    component: () => import("../views/pages/customers_design/favourites.vue"),
    meta: {
      title: "/my-favourites",
    },
  },
  {
    path: "/my-profile",
    name: "/my-profile",
    props: true, 
    component: () => import("../views/pages/customers_design/profilenew.vue"),
    meta: {
      title: "/my-profile",
    },
  },
  {
    path: "/my-review",
    name: "/my-review",
    props: true, 
    component: () => import("../views/pages/customers_design/reviews.vue"),
    meta: {
      title: "/my-review",
    },
  },
  {
    path: "/review-confirm",
    name: "/review-confirm",
    props: true, 
    component: () => import("../views/pages/customers_design/reviews_confirm.vue"),
    meta: {
      title: "/review-confirm",
    },
  },

  {
    path: "/buy-membership",
    name: "/buy-membership",
    props: true, 
    component: () => import("../views/pages/customers_design/buy_membership.vue"),
    meta: {
      title: "/buy-membership",
    },
  },
  {
    path: "/referals",
    name: "/referals",
    props: true, 
    component: () => import("../views/pages/customers_design/referals.vue"),
    meta: {
      title: "/referals",
    },
  },
  {
    path: "/my-membership-list",
    name: "/my-membership-list",
    props: true, 
    component: () => import("../views/pages/customers_design/mymembershiplist.vue"),
    meta: {
      title: "/my-membership-list",
    },
  },

  {
    path: "/remainder-master",
    name: "remainder-master",
    component: () => import("../views/pages/RemainderMaster/remainder_master"),
    meta: {
      title: "Remainder Master",
    },
  },



  // {
  //   path: "/dashboard/crypto",
  //   name: "dashboard-crypto",
  //   meta: {
  //     title: "Crypto",
  //     authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/crypto/index"),
  // },
  // {
  //   path: "/dashboard/projects",
  //   name: "dashboard-projects",
  //   meta: {
  //     title: "Projects", authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/projects/index"),
  // },
  // {
  //   path: "/dashboard/crm",
  //   name: "dashboard-crm",
  //   meta: {
  //     title: "CRM", authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/crm/index"),
  // },
  // {
  //   path: "/dashboard/analytics",
  //   name: "dashboard-analytics",
  //   meta: {
  //     title: "Analytics", authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/analytics/index"),
  // },
  // {
  //   path: "/dashboard/nft",
  //   name: "dashboard-nft",
  //   meta: {
  //     title: "NFT Dashboard", authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/nft/index"),
  // },
  // {
  //   path: "/dashboard/job",
  //   name: "dashboard-job",
  //   meta: {
  //     title: "Job Dashboard", authRequired: true,
  //   },
  //   component: () => import("../views/dashboard/job/index"),
  // },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/chat",
    name: "chat",
    meta: { title: "Chat", authRequired: true },
    component: () => import("../views/apps/chat"),
  },
  {
    path: "/apps-file-manager",
    name: "file manager",
    meta: { title: "File Manager", authRequired: true },
    component: () => import("../views/apps/filemanager"),
  },
  {
    path: "/apps-todo",
    name: "To Do List",
    meta: { title: "To Do List", authRequired: true },
    component: () => import("../views/apps/todo"),
  },
  {
    path: "/mailbox",
    name: "mailbox",
    meta: { title: "Mailbox", authRequired: true },
    component: () => import("../views/apps/email/mailbox"),
  },
  {
    path: "/email/email-basic",
    name: "email-basic",
    meta: { title: "Basic Action", authRequired: true },
    component: () => import("../views/apps/email/email-basic"),
  },
  {
    path: "/email/email-ecommerce",
    name: "email-ecommerce",
    meta: { title: "Ecommerce Action", authRequired: true },
    component: () => import("../views/apps/email/email-ecommerce"),
  },
  {
    path: "/apps/nft-auction",
    name: "auction",
    meta: { title: "Live Auction", authRequired: true },
    component: () => import("../views/apps/nft/nft-auction"),
  },
  {
    path: "/apps/nft-collection",
    name: "collection",
    meta: { title: "Collactions", authRequired: true },
    component: () => import("../views/apps/nft/nft-collection"),
  },
  {
    path: "/apps/nft-create",
    name: "create",
    meta: { title: "Create", authRequired: true },
    component: () => import("../views/apps/nft/nft-create"),
  },
  {
    path: "/apps/nft-creators",
    name: "creators",
    meta: { title: "Creators", authRequired: true },
    component: () => import("../views/apps/nft/nft-creators"),
  },
  {
    path: "/apps/nft-explore",
    name: "explore",
    meta: { title: "Explore Now", authRequired: true },
    component: () => import("../views/apps/nft/nft-explore"),
  },
  {
    path: "/apps/nft-item-detail",
    name: "item-detail",
    meta: { title: "Item Detail", authRequired: true },
    component: () => import("../views/apps/nft/nft-item-detail"),
  },
  {
    path: "/apps/nft-marketplace",
    name: "marketplace",
    meta: { title: "Marketplace", authRequired: true },
    component: () => import("../views/apps/nft/nft-marketplace"),
  },
  {
    path: "/apps/nft-ranking",
    name: "ranking",
    meta: { title: "Ranking", authRequired: true },
    component: () => import("../views/apps/nft/nft-ranking"),
  },
  {
    path: "/apps/nft-wallet",
    name: "nft-wallet",
    meta: { title: "Wallet", authRequired: true },
    component: () => import("../views/apps/nft/nft-wallet"),
  },
  {
    path: "/apps/projects-list",
    name: "projects-list",
    meta: { title: "Projects List", authRequired: true },
    component: () => import("../views/apps/projects/list"),
  },
  {
    path: "/apps/projects-overview",
    name: "projects Overview",
    meta: { title: "Projects Overview", authRequired: true },
    component: () => import("../views/apps/projects/overview"),
  },
  {
    path: "/apps/projects-create",
    name: "projects-create",
    meta: { title: "Projects Create", authRequired: true },
    component: () => import("../views/apps/projects/create"),
  },
  {
    path: "/apps/tasks-details",
    name: "tasks-details",
    meta: { title: "Tasks Details", authRequired: true },
    component: () => import("../views/apps/tasks/details"),
  },
  {
    path: "/apps/tasks-kanban",
    name: "tasks-kanban",
    meta: { title: "Tasks Kanban", authRequired: true },
    component: () => import("../views/apps/tasks/kanban"),
  },
  {
    path: "/apps/tasks-list-view",
    name: "tasks-list-view",
    meta: { title: "Taks List", authRequired: true },
    component: () => import("../views/apps/tasks/list-view"),
  },
  {
    path: "/apps/crm-contacts",
    name: "crm-contacts",
    meta: { title: "CRM Contacts", authRequired: true },
    component: () => import("../views/apps/crm/contacts"),
  },
  {
    path: "/apps/crm-companies",
    name: "crm-companies",
    meta: { title: "CRM companies", authRequired: true },
    component: () => import("../views/apps/crm/companies"),
  },
  {
    path: "/apps/crm-deals",
    name: "crm-deals",
    meta: { title: "CRM Deals", authRequired: true },
    component: () => import("../views/apps/crm/deals"),
  },
  {
    path: "/apps/crm-leads",
    name: "crm-leads",
    meta: { title: "CRM Leads", authRequired: true },
    component: () => import("../views/apps/crm/leads"),
  },
  {
    path: "/ecommerce/customers",
    name: "customers",
    meta: { title: "Customers", authRequired: true },
    component: () => import("../views/apps/ecommerce/customers"),
  },
  {
    path: "/ecommerce/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("../views/apps/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-details",
    name: "product-detail",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/product-details"),
  },
  {
    path: "/ecommerce/orders",
    name: "orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/ecommerce/orders"),
  },
  {
    path: "/ecommerce/order-details",
    name: "order-details",
    meta: { title: "Order Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/order-details"),
  },
  {
    path: "/ecommerce/add-product",
    name: "add-product",
    meta: { title: "Create Product", authRequired: true },
    component: () => import("../views/apps/ecommerce/add-product"),
  },
  {
    path: "/ecommerce/shopping-cart",
    name: "shopping cart",
    meta: { title: "Shopping Cart", authRequired: true },
    component: () => import("../views/apps/ecommerce/shopping-cart"),
  },
  {
    path: "/ecommerce/checkout",
    name: "checkout",
    meta: { title: "Check Out", authRequired: true },
    component: () => import("../views/apps/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/sellers",
    name: "sellers",
    meta: { title: "Sellers", authRequired: true },
    component: () => import("../views/apps/ecommerce/sellers"),
  },
  {
    path: "/ecommerce/seller-details",
    name: "seller-details",
    meta: { title: "Seller Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/seller-details"),
  },
  {
    path: "/crypto/buy-sell",
    name: "buy/sell",
    meta: { title: "Buy & Sell", authRequired: true },
    component: () => import("../views/apps/crypto/buy-sell"),
  },
  {
    path: "/crypto/kyc",
    name: "kyc",
    meta: { title: "KYC Application", authRequired: true },
    component: () => import("../views/apps/crypto/kyc"),
  },
  {
    path: "/crypto/ico",
    name: "ico",
    meta: { title: "ICO List", authRequired: true },
    component: () => import("../views/apps/crypto/ico"),
  },
  {
    path: "/crypto/orders",
    name: "crypto-orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/crypto/orders"),
  },
  {
    path: "/crypto/wallet",
    name: "wallet",
    meta: { title: "My Wallet", authRequired: true },
    component: () => import("../views/apps/crypto/wallet"),
  },
  {
    path: "/crypto/transactions",
    name: "transactions",
    meta: { title: "Transactions", authRequired: true },
    component: () => import("../views/apps/crypto/transactions"),
  },
  {
    path: "/invoices/detail/:id?",
    name: "invoice-detail",
    meta: { title: "Invoice Details", authRequired: true },
    component: () => import("../views/apps/invoices/details"),
  },
  {
    path: "/invoices/list",
    name: "invoice-list",
    meta: { title: "Invoice List", authRequired: true },
    component: () => import("../views/apps/invoices/list"),
  },
  {
    path: "/invoices/create",
    name: "invoice-create",
    meta: { title: "Create Invoice", authRequired: true },
    component: () => import("../views/apps/invoices/create"),
  },
  {
    path: "/jobs/application",
    name: "job-application",
    meta: { title: "Job Application", authRequired: true },
    component: () => import("../views/apps/jobs/application"),
  },
  {
    path: "/jobs/candidate-grid",
    name: "job-candidate-grid",
    meta: { title: "Candidate Grid", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-grid"),
  },
  {
    path: "/jobs/candidate-lists",
    name: "job-candidate-lists",
    meta: { title: "Candidate Lists", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-lists"),
  },
  {
    path: "/jobs/categories",
    name: "job-categories",
    meta: { title: "Job Categories", authRequired: true },
    component: () => import("../views/apps/jobs/categories"),
  },
  {
    path: "/jobs/companies-list",
    name: "job-companies-list",
    meta: { title: "Companies List", authRequired: true },
    component: () => import("../views/apps/jobs/companies-list"),
  },
  {
    path: "/jobs/details",
    name: "job-details",
    meta: { title: "Job Details", authRequired: true },
    component: () => import("../views/apps/jobs/details"),
  },
  {
    path: "/jobs/grid-lists",
    name: "job-grid-lists",
    meta: { title: "Grid Lists", authRequired: true },
    component: () => import("../views/apps/jobs/grid-lists"),
  },
  {
    path: "/jobs/lists",
    name: "job-lists",
    meta: { title: "Job Lists", authRequired: true },
    component: () => import("../views/apps/jobs/lists"),
  },
  {
    path: "/jobs/new",
    name: "job-new",
    meta: { title: "New Job", authRequired: true },
    component: () => import("../views/apps/jobs/new"),
  },
  {
    path: "/jobs/statistics",
    name: "job-statistics",
    meta: { title: "Job Statistics", authRequired: true },
    component: () => import("../views/apps/jobs/statistics"),
  },
  {
    path: "/apps-api-key",
    name: "API Key",
    meta: { title: "API Key", authRequired: true },
    component: () => import("../views/apps/apikey"),
  },
  // {
  //   path: "/pages/starter",
  //   name: "starter",
  //   meta: { title: "Starter", authRequired: true },
  //   component: () => import("../views/pages/starter"),
  // },
  // {
  //   path: "/pages/profile",
  //   name: "profile",
  //   meta: { title: "Profile", authRequired: true },
  //   component: () => import("../views/pages/profile/simple"),
  // },
  // {
  //   path: "/pages/profile-setting",
  //   name: "profile-setting",
  //   meta: { title: "Setting", authRequired: true },
  //   component: () => import("../views/pages/profile/setting"),
  // },
  // {
  //   path: "/pages/maintenance",
  //   name: "maintenance",
  //   meta: { title: "Maintanance", authRequired: true },
  //   component: () => import("../views/pages/maintenance"),
  // },
  // {
  //   path: "/pages/coming-soon",
  //   name: "coming-soon",
  //   meta: { title: "Comming Soon", authRequired: true },
  //   component: () => import("../views/pages/coming-soon"),
  // },
  // {
  //   path: "/pages/timeline",
  //   name: "timeline",
  //   meta: { title: "Timeline", authRequired: true },
  //   component: () => import("../views/pages/timeline"),
  // },
  // {
  //   path: "/pages/faqs",
  //   name: "FAQs",
  //   meta: { title: "FAQs", authRequired: true },
  //   component: () => import("../views/pages/faqs"),
  // },
  // {
  //   path: "/pages/pricing",
  //   name: "pricing",
  //   meta: { title: "Pricing", authRequired: true },
  //   component: () => import("../views/pages/pricing"),
  // },
  // {
  //   path: "/pages/team",
  //   name: "team",
  //   meta: { title: "Team", authRequired: true },
  //   component: () => import("../views/pages/team"),
  // },
  // {
  //   path: "/pages/search-results",
  //   name: "search-results",
  //   meta: { title: "Search Results", authRequired: true },
  //   component: () => import("../views/pages/search-results"),
  // },
  // {
  //   path: "/pages/sitemap",
  //   name: "sitemap",
  //   meta: { title: "Sitemap", authRequired: true },
  //   component: () => import("../views/pages/sitemap"),
  // },
  // {
  //   path: "/pages/privacy-policy",
  //   name: "privacy-policy",
  //   meta: { title: "Privacy Policy", authRequired: true },
  //   component: () => import("../views/pages/privacy-policy"),
  // },
  // {
  //   path: "/pages/term-conditions",
  //   name: "term-conditions",
  //   meta: { title: "Term Conditions", authRequired: true },
  //   component: () => import("../views/pages/term-conditions"),
  // },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: true,
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: true,
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
  //
  {
    path: '/pages/Home/Home',
    name: 'Home',
    meta: {title: "Home", authRequired: true,},
    component: () => import('../views/pages/Home/Home')
  },
  // {
  //   path: '/pages/master/FloorMaster',
  //   name: 'Floor Master',
  //   meta: {title: "Floor Master", authRequired: true,},
  //   component: () => import('../views/pages/master/FloorMaster')
  // },
  // {
  //   path: '/pages/master/WingMaster',
  //   name: 'Wing Master',
  //   meta: {title: "Wing Master", authRequired: true,},
  //   component: () => import('../views/pages/master/WingMaster')
  // },
  // {
  //   path: '/pages/master/RoomMaster',
  //   name: 'Room Master',
  //   meta: {title: "Room Master", authRequired: true,},
  //   component: () => import('../views/pages/master/RoomMaster')
  // },
  // {
  //   path: '/pages/master/RoleMaster',
  //   name: 'Role Master',
  //   meta: {title: "Role Master", authRequired: true,},
  //   component: () => import('../views/pages/master/RoleMaster')
  // },
  // {
  //   path: '/pages/master/AdminMaster',
  //   name: 'Admin Master',
  //   meta: {title: "Admin Master", authRequired: true,},
  //   component: () => import('../views/pages/master/AdminMaster')
  // },
  // {
  //   path: '/pages/master/EmployeeMaster',
  //   name: 'Employee Master',
  //   meta: {title: "Employee Master", authRequired: true,},
  //   component: () => import('../views/pages/master/EmployeeMaster')
  // },
  // {
  //   path: '/pages/master/EBCost',
  //   name: 'EBCost Master',
  //   meta: {title: "EBCost Master", authRequired: true,},
  //   component: () => import('../views/pages/master/EBCost')
  // },
  // {
  //   path: '/pages/master/TermsandConditionMaster',
  //   name: 'Terms and Condition Master',
  //   meta: {title: "Terms and Condition Master", authRequired: true,},
  //   component: () => import('../views/pages/master/TermsandConditionMaster')
  // },
  // {
  //   path: '/pages/master/ParkingVehicleMaster',
  //   name: 'Parking Vehicle Master',
  //   meta: {title: "Parking Vehicle Master", authRequired: true,},
  //   component: () => import('../views/pages/master/ParkingVehicleMaster')
  // },
  // {
  //   path: '/pages/master/CustomerParkingFee',
  //   name: 'Customer Parking Fee Master',
  //   meta: {title: "Customer Parking Fee Master", authRequired: true,},
  //   component: () => import('../views/pages/master/CustomerParkingFee')
  // },
  // {
  //   path: '/pages/master/GuestParkingFee',
  //   name: 'Guest Parking Fee Master',
  //   meta: {title: "Guest Parking Fee Master", authRequired: true,},
  //   component: () => import('../views/pages/master/GuestParkingFee')
  // },
  // {
  //   path: '/pages/master/TaxMaster',
  //   name: 'Tax Master',
  //   meta: {title: "Tax Master", authRequired: true,},
  //   component: () => import('../views/pages/master/TaxMaster')
  // },
  // {
  //   path: '/pages/master/Charges',
  //   name: 'Charges Master',
  //   meta: {title: "Charges Master", authRequired: true,},
  //   component: () => import('../views/pages/master/Charges')
  // },
  // {
  //   path: '/pages/master/TaxDetail',
  //   name: 'Tax Detail',
  //   meta: {title: "Tax Master", authRequired: true,},
  //   component: () => import('../views/pages/master/TaxDetail')
  // },
  // {
  //   path: '/pages/CustomerOnBoardingProcess',
  //   name: 'Customer On Boarding Process',
  //   meta: {title: "Customer On Boarding Process", authRequired: true,},
  //   component: () => import('../views/pages/CustomerOnBoardingProcess')
  // },
  // {
  //   path: '/pages/CustomerOnBoardingProcessList',
  //   name: 'Customer On Boarding Process List',
  //   meta: {title: "Customer On Boarding Process List", authRequired: true,},
  //   component: () => import('../views/pages/CustomerOnBoardingProcessList')
  // },
  // {
  //   path: '/pages/CustomerExitBoardingProcess',
  //   name: 'Customer Exit Boarding Process',
  //   meta: {title: "Customer Exit Boarding Process", authRequired: true,},
  //   component: () => import('../views/pages/CustomerExitBoardingProcess')
  // },
  // {
  //   path: '/pages/CleaningSchedule',
  //   name: 'Cleaning Schedule',
  //   meta: {title: "Cleaning Schedule", authRequired: true,},
  //   component: () => import('../views/pages/CleaningSchedule')
  // },
  // {
  //   path: '/pages/MonthlyEBCalculation',
  //   name: 'Monthly EB Calculation',
  //   meta: {title: "Monthly EB Calculation", authRequired: true,},
  //   component: () => import('../views/pages/MonthlyEBCalculation')
  // },
  // {
  //   path: '/pages/MonthlyRentBill',
  //   name: 'Monthly Rent Bill',
  //   meta: {title: "Monthly Rent Bill", authRequired: true,},
  //   component: () => import('../views/pages/MonthlyRentBill')
  // },
  // {
  //   path: '/pages/GuestDetails',
  //   name: 'Guest Details',
  //   meta: {title: "Guest Details", authRequired: true,},
  //   component: () => import('../views/pages/GuestDetails')
  // },
  // {
  //   path: '/pages/RoomServiceRequest',
  //   name: 'Room Service Request',
  //   meta: {title: "Room Service Request", authRequired: true,},
  //   component: () => import('../views/pages/RoomServiceRequest')
  // },
  // {
  //   path: '/pages/RoomExchangeandHistory/RoomExchange',
  //   name: 'Room Exchange',
  //   meta: {title: "Room Exchange", authRequired: true,},
  //   component: () => import('../views/pages/RoomExchangeandHistory/RoomExchange')
  // },
  // {
  //   path: '/pages/RoomExchangeandHistory/RoomHistory',
  //   name: 'Room History',
  //   meta: {title: "Room History", authRequired: true,},
  //   component: () => import('../views/pages/RoomExchangeandHistory/RoomHistory')
  // },
  // {
  //   path: '/pages/ExpensesandProfit/Expenses',
  //   name: 'Expenses',
  //   meta: {title: "Expenses", authRequired: true,},
  //   component: () => import('../views/pages/ExpensesandProfit/Expenses')
  // },
  // {
  //   path: '/pages/ExpensesandProfit/Profit',
  //   name: 'Profit',
  //   meta: {title: "Profit", authRequired: true,},
  //   component: () => import('../views/pages/ExpensesandProfit/Profit')
  // },
  // {
  //   path: '/pages/EmployeeAttendance',
  //   name: 'Employee Attendance',
  //   meta: {title: "Employee Attendance", authRequired: true,},
  //   component: () => import('../views/pages/EmployeeAttendance')
  // },
  // {
  //   path: '/pages/EmployeeSalary',
  //   name: 'Employee Salary',
  //   meta: {title: "Employee Salary", authRequired: true,},
  //   component: () => import('../views/pages/EmployeeSalary')
  // },
  // {
  //   path: '/pages/PrivacyPolicy/privacy-policy',
  //   name: 'Privacy Policy',
  //   meta: {title: "Privacy Policy", authRequired: true,},
  //   component: () => import('../views/pages/PrivacyPolicy/privacy_policy')
  // },
];